import { render, staticRenderFns } from "./headerStat.vue?vue&type=template&id=5b31fff6&lang=pug&"
import script from "./headerStat.vue?vue&type=script&lang=js&"
export * from "./headerStat.vue?vue&type=script&lang=js&"
import style0 from "./headerStat.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "headerStat.vue"
export default component.exports